// @ts-nocheck
import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
} from "@mui/material";
import { UploadFile as UploadFileIcon } from "@mui/icons-material";
import { CloseButton } from "../../../Componentes/feedback/dialog/CloseButton";

const Ejemplo = ({ children }) => (
    <Box
        component="pre"
        sx={{
            m: 0,
            p: 1.5,
            bgcolor: "#f5f5f5",
            borderRadius: 1,
            fontSize: "0.8rem",
            lineHeight: 1.6,
            overflowX: "auto",
        }}
    >
        {children}
    </Box>
);

export const ImportarCSVModal = ({ open, onClose, onSeleccionarArchivo }) => (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ m: 0, p: 2, pr: 6, position: "relative" }}>
            <Typography variant="h6" component="div">
                Importar destinatarios desde CSV
            </Typography>
            <CloseButton onClose={onClose} />
        </DialogTitle>

        <DialogContent dividers>
            <Typography variant="body2" gutterBottom>
                Del archivo se toman únicamente los correos. Los nombres, legajos
                y demás columnas se ignoran solos.
            </Typography>

            <Box sx={{ my: 2 }}>
                <Typography variant="caption" color="text.secondary">
                    Una sola columna
                </Typography>
                <Ejemplo>
                    {"correo\njuan@frba.utn.edu.ar\nana@frba.utn.edu.ar"}
                </Ejemplo>
            </Box>

            <Box sx={{ my: 2 }}>
                <Typography variant="caption" color="text.secondary">
                    Varias columnas
                </Typography>
                <Ejemplo>
                    {"Nombre;Apellido;Correo\nJuan;Perez;juan@frba.utn.edu.ar"}
                </Ejemplo>
            </Box>

            <Typography variant="body2" component="div" color="text.secondary">
                <ul style={{ margin: 0, paddingLeft: "1.2rem" }}>
                    <li>El correo puede estar en cualquier columna.</li>
                    <li>Sirve coma, punto y coma o tabulación como separador.</li>
                    <li>Si la primera fila es un encabezado, se descarta.</li>
                </ul>
            </Typography>
        </DialogContent>

        <DialogActions>
            <Button sx={{ textTransform: "none" }} onClick={onClose}>
                Cancelar
            </Button>
            <Button
                sx={{ textTransform: "none" }}
                variant="contained"
                color="primary"
                startIcon={<UploadFileIcon />}
                onClick={onSeleccionarArchivo}
            >
                Seleccionar archivo
            </Button>
        </DialogActions>
    </Dialog>
);
